export default __webpack_public_path__ + "static/media/355.fa33b63e.png";